import { render, staticRenderFns } from "./CardAgentLarge.vue?vue&type=template&id=a63a0ff4&scoped=true"
import script from "./CardAgentLarge.vue?vue&type=script&lang=js"
export * from "./CardAgentLarge.vue?vue&type=script&lang=js"
import style0 from "./CardAgentLarge.vue?vue&type=style&index=0&id=a63a0ff4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a63a0ff4",
  null
  
)

export default component.exports